import React from 'react'

const Manual_cliente_natural_sv = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Creación de un Cliente Natural | El Salvador
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Para facturar correctamente, es necesario registrar al cliente en el sistema. Sigue estos pasos para crear un Cliente Natural en el POS de Invu:
        </p>
        <iframe
          className="scribe-iframe-general-60"
          src="https://scribehow.com/embed/Creacion_de_un_Cliente_Natural_or_El_Salvador___e6sVlH-jReuW8uiHW2xFtw?as=scrollable"
          width="100%"
          height="6450"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cliente_natural_sv
